/* ============================================================================
   LUXURY COLLECTION REFINE
   - Sort popover (button + menu, outside-click + ESC close)
   - Refine drawer (slide-in from right on desktop, bottom-sheet on mobile)
   - Reveal More (AJAX append via Section Rendering API)
   - Active filter chips (instant remove + reload)
   No frameworks. Progressive enhancement: links/forms work without JS.
   ============================================================================ */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  /* -------------------------------------------------------------------- SORT */
  function initSort(root) {
    var trigger = root.querySelector('[data-lux-sort-trigger]');
    var menu = root.querySelector('[data-lux-sort-menu]');
    if (!trigger || !menu) return;

    function close() {
      trigger.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
      document.removeEventListener('click', onOutside, true);
      document.removeEventListener('keydown', onKey);
    }
    function open() {
      trigger.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
      setTimeout(function () {
        document.addEventListener('click', onOutside, true);
        document.addEventListener('keydown', onKey);
      }, 0);
      var checked = menu.querySelector('[aria-checked="true"]') || menu.querySelector('[role="menuitemradio"]');
      if (checked) checked.focus();
    }
    function onOutside(e) {
      if (!root.contains(e.target)) close();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    }
    trigger.addEventListener('click', function () {
      if (trigger.getAttribute('aria-expanded') === 'true') close(); else open();
    });
  }

  /* ------------------------------------------------------------------ DRAWER */
  function initDrawer() {
    var drawer = document.querySelector('[data-lux-refine-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-lux-refine-open]');
    var closers = drawer.querySelectorAll('[data-lux-refine-close]');
    var panel = drawer.querySelector('.lux-refine__panel');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      setTimeout(function () {
        var first = panel.querySelector(FOCUSABLE);
        if (first) first.focus();
      }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { drawer.setAttribute('hidden', ''); }, 400);
      if (lastFocus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    }
    function trapFocus(e) {
      var nodes = panel.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    openers.forEach(function (o) { o.addEventListener('click', open); });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) {
      if (e.target.matches('.lux-refine__scrim')) close();
    });

    /* Collapsible groups inside the drawer */
    drawer.querySelectorAll('[data-lux-refine-group]').forEach(function (group) {
      var head = group.querySelector('.lux-refine__group-head');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = group.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --------------------------------------------------------------- LOAD MORE */
  function initLoadMore() {
    var btn = document.querySelector('[data-lux-reveal-more]');
    if (!btn) return;
    var grid = document.querySelector('#product-grid');
    var counter = document.querySelector('[data-lux-count]');
    if (!grid) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var nextUrl = btn.getAttribute('href');
      if (!nextUrl || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      var sectionId = btn.getAttribute('data-section-id');
      var sep = nextUrl.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = nextUrl + sep + 'section_id=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          var newCounter = doc.querySelector('[data-lux-count]');
          var newReveal = doc.querySelector('[data-lux-reveal-more]');
          if (newGrid) {
            var frag = document.createDocumentFragment();
            var addedImgs = [];
            var addedItems = [];
            Array.from(newGrid.children).forEach(function (li) {
              // Force-load images on appended cards (lazy-load doesn't re-fire after JS insertion)
              li.querySelectorAll('img').forEach(function (img) {
                img.setAttribute('loading', 'eager');
                img.setAttribute('decoding', 'async');
                addedImgs.push(img);
              });
              // Force-show appended cards — bypass IntersectionObserver-based reveal.
              // `.lux-card { opacity:0; transform:translateY(10px) }` until `.is-in` is added
              // (see card-product-luxury.css). The observer is only wired on initial page load,
              // so freshly appended cards would stay invisible without this. Reveal-more cards
              // are user-initiated, so showing them immediately (no fade-in) is the right behaviour.
              li.querySelectorAll('.lux-card').forEach(function (card) {
                card.classList.add('is-in');
              });
              addedItems.push(li);
              frag.appendChild(li);
            });
            grid.appendChild(frag);
            // Kick decode for any image that didn't auto-start
            addedImgs.forEach(function (img) {
              if (!img.complete) {
                var src = img.currentSrc || img.src;
                if (src) {
                  // Re-assigning src forces the loader to engage on injected nodes
                  img.src = src;
                  if (typeof img.decode === 'function') { img.decode().catch(function(){}); }
                }
              }
            });
            // Re-run card controller hooks for the appended subtree
            // (IntersectionObserver + wishlist hydration). The `.is-in` class
            // is also pre-applied above so cards are visible immediately even
            // if the observer hasn't fired yet (cards may be below the fold).
            if (window.LuxCard && typeof window.LuxCard.refresh === 'function') {
              addedItems.forEach(function (li) { window.LuxCard.refresh(li); });
            }
            // Let other systems (analytics, etc.) react to appended cards.
            document.dispatchEvent(new CustomEvent('lux:grid:appended', {
              detail: { items: addedItems, grid: grid }
            }));
          }
          if (counter && newCounter) counter.innerHTML = newCounter.innerHTML;
          if (newReveal) {
            btn.setAttribute('href', newReveal.getAttribute('href'));
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
          } else {
            btn.parentNode && btn.parentNode.removeChild(btn);
          }
          // NOTE: deliberately NOT updating browser URL. Reveal-more is a
          // progressive disclosure of page 1; rewriting URL to `?page=N` causes
          // a refresh to land on Shopify's page-N view (a different product set),
          // which contradicts the "load more" mental model.
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          window.location.href = nextUrl;
        });
    });
  }

  /* ----------------------------------------------------------------- INIT */
  function init() {
    document.querySelectorAll('[data-lux-sort]').forEach(initSort);
    initDrawer();
    initLoadMore();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
